import React from 'react';
import {
  AlertTriangle,
  Bell,
  Calendar,
  CheckCircle2,
  Clock,
  FileCheck,
  FileText,
  FolderOpen,
  Key,
  MessageCircle,
  RefreshCw,
  Share2,
  Shield,
  Unlock,
  Upload,
  UserMinus,
  UserPlus,
  Zap,
} from 'lucide-react';

// Ícone e cor de fundo de cada tipo de notificação — um lugar só, usado pelo
// sino (Header) e pela página de Notificações.

const ICONES: Record<string, React.ComponentType<{ className?: string }>> = {
  task_assigned: UserPlus,
  task_completed: CheckCircle2,
  task_overdue: Clock,
  task_due_soon: Calendar,
  task_status_changed: RefreshCw,
  task_commented: MessageCircle,
  chat_mention: MessageCircle,
  chat_new_message: MessageCircle,
  timer_running_long: Clock,
  project_hours_budget: AlertTriangle,
  file_uploaded: Upload,
  file_updated: FileText,
  file_shared: Share2,
  document_approval_requested: FileCheck,
  project_member_added: UserPlus,
  project_member_removed: UserMinus,
  role_changed: Shield,
  access_requested: Key,
  access_granted: Unlock,
  meeting_scheduled: Calendar,
  integration_event: Zap,
  system_error: AlertTriangle,
  // Tipos antigos
  file_expiring: Clock,
  folder_access: FolderOpen,
  folder_opened: FolderOpen,
  transfer_complete: CheckCircle2,
};

const CORES: Record<string, string> = {
  task_assigned: 'bg-coral',
  task_completed: 'bg-nk-success',
  task_overdue: 'bg-nk-error',
  task_due_soon: 'bg-nk-warn',
  timer_running_long: 'bg-nk-warn',
  project_hours_budget: 'bg-nk-error',
  chat_mention: 'bg-nk-info',
  chat_new_message: 'bg-nk-info',
  file_uploaded: 'bg-nk-info',
};

export function NotificationIcon({ type, className = 'w-5 h-5 text-white' }: { type?: string; className?: string }) {
  const Icone = (type && ICONES[type]) || Bell;
  return <Icone className={className} />;
}

// eslint-disable-next-line react-refresh/only-export-components
export function notificationColor(type?: string): string {
  return (type && CORES[type]) || 'bg-ink-400';
}

// eslint-disable-next-line react-refresh/only-export-components
export function formatNotificationDate(dateString?: string | null): string {
  if (!dateString) return '';
  const date = new Date(dateString);
  if (isNaN(date.getTime())) return '';
  return date.toLocaleDateString('pt-BR', {
    day: '2-digit',
    month: 'short',
    hour: '2-digit',
    minute: '2-digit',
  });
}
